import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { publicApi } from "@/lib/api";
import { SectionHeading, PropertyCard, Loader, CATEGORY_LABELS } from "@/components/public/ui";

const FILTERS = [
  { key: "all", label: "All" },
  { key: "dine", label: "Dine" },
  { key: "stay", label: "Stay" },
  { key: "dock", label: "Dock" },
  { key: "gather", label: "Gather" },
];

export default function Portfolio() {
  const [params, setParams] = useSearchParams();
  const active = params.get("category") || "all";
  const [properties, setProperties] = useState(null);

  useEffect(() => {
    publicApi.get("/properties").then((r) => setProperties(r.data)).catch(() => setProperties([]));
  }, []);

  const filtered = useMemo(() => {
    if (!properties) return [];
    if (active === "all") return properties;
    return properties.filter((p) => (p.categories || []).includes(active));
  }, [properties, active]);

  const setActive = (k) => setParams(k === "all" ? {} : { category: k });

  return (
    <div className="pt-20">
      <section className="bg-[#18344A] py-20 text-white">
        <div className="mx-auto max-w-[1280px] px-5 lg:px-8">
          <SectionHeading eyebrow="The Portfolio" title="Our Places" light
            intro="Distinctive restaurants, stays, marinas and gathering places across Coastal Virginia." />
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-5 py-14 lg:px-8">
        <div className="mb-10 flex flex-wrap gap-2" data-testid="portfolio-filters">
          {FILTERS.map((f) => (
            <button key={f.key} onClick={() => setActive(f.key)} data-testid={`portfolio-filter-${f.key}`}
              className={`rounded-full px-5 py-2 text-sm font-medium uppercase tracking-[0.06em] transition-colors ${
                active === f.key ? "bg-[#18344A] text-white" : "border border-[var(--pb-border)] bg-white text-[#526E7E] hover:border-[#526E7E]"
              }`}>
              {f.label}
            </button>
          ))}
        </div>

        {properties === null ? (
          <Loader />
        ) : filtered.length === 0 ? (
          <p className="py-20 text-center text-[rgba(48,56,60,0.6)]">No properties in this category yet.</p>
        ) : (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {filtered.map((p, i) => <PropertyCard key={p.id} p={p} large={i === 0 && active === "all"} />)}
          </div>
        )}
      </section>
    </div>
  );
}
